import { toast } from 'react-toastify'

export const ToastPosition = toast.POSITION
